var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/nrk-types.ts
var ClickEventKind = /* @__PURE__ */ ((ClickEventKind2) => {
  ClickEventKind2["Content"] = "content";
  ClickEventKind2["Other"] = "other";
  return ClickEventKind2;
})(ClickEventKind || {});
var ImpressionEventKind = /* @__PURE__ */ ((ImpressionEventKind2) => {
  ImpressionEventKind2["Impression"] = "impression";
  return ImpressionEventKind2;
})(ImpressionEventKind || {});
var PlaybackEventKind = /* @__PURE__ */ ((PlaybackEventKind2) => {
  PlaybackEventKind2["Complete"] = "complete";
  PlaybackEventKind2["Exit"] = "exit";
  PlaybackEventKind2["Progress"] = "progress";
  PlaybackEventKind2["Start"] = "start";
  return PlaybackEventKind2;
})(PlaybackEventKind || {});
var SearchSource = /* @__PURE__ */ ((SearchSource2) => {
  SearchSource2["PopularSearch"] = "popular-search";
  SearchSource2["PreviousResult"] = "previous-result";
  SearchSource2["Search"] = "search";
  return SearchSource2;
})(SearchSource || {});
var EventSchema = /* @__PURE__ */ ((EventSchema3) => {
  EventSchema3["BackstageEvent"] = "iglu:no.nrk.innlogging/backstage-event/jsonschema/1-0-0";
  EventSchema3["ClickEvent"] = "iglu:no.nrk/click-event/jsonschema/1-0-0";
  EventSchema3["FrontstageServerEvent"] = "iglu:no.nrk.innlogging/frontstage-server-event/jsonschema/1-0-0";
  EventSchema3["ImpressionEvent"] = "iglu:no.nrk/impression-event/jsonschema/1-0-0";
  EventSchema3["LoginRegisterFlowEvent"] = "iglu:no.nrk.innlogging/login-register-flow-event/jsonschema/1-0-0";
  EventSchema3["PlaybackEvent"] = "iglu:no.nrk/playback-event/jsonschema/1-0-0";
  EventSchema3["ProfilePageEvent"] = "iglu:no.nrk.innlogging/profile-page-event/jsonschema/1-0-0";
  EventSchema3["RadioEvent"] = "iglu:no.nrk.radio/radio-event/jsonschema/1-0-0";
  EventSchema3["TimeSpentEvent"] = "iglu:no.nrk/time-spent-event/jsonschema/1-0-0";
  return EventSchema3;
})(EventSchema || {});
var EntitySchema = /* @__PURE__ */ ((EntitySchema2) => {
  EntitySchema2["ClientID"] = "iglu:no.nrk.innlogging/client-id/jsonschema/1-0-0";
  EntitySchema2["Content"] = "iglu:no.nrk/content/jsonschema/1-0-1";
  EntitySchema2["Experiment"] = "iglu:no.nrk/experiment/jsonschema/1-0-0";
  EntitySchema2["Link"] = "iglu:no.nrk/link/jsonschema/2-0-0";
  EntitySchema2["NrkSession"] = "iglu:no.nrk/nrk-session/jsonschema/1-0-0";
  EntitySchema2["NrkUser"] = "iglu:no.nrk/nrk-user/jsonschema/1-0-0";
  EntitySchema2["Plug"] = "iglu:no.nrk/plug/jsonschema/3-0-0";
  EntitySchema2["PreviousWebPage"] = "iglu:no.nrk/previous-web-page/jsonschema/1-0-0";
  EntitySchema2["RegistrationContext"] = "iglu:no.nrk.innlogging/registration-context/jsonschema/1-0-0";
  EntitySchema2["SearchResult"] = "iglu:no.nrk/search-result/jsonschema/1-0-1";
  EntitySchema2["Service"] = "iglu:no.nrk/service/jsonschema/2-0-0";
  EntitySchema2["Application"] = "iglu:com.snowplowanalytics.mobile/application/jsonschema/1-0-0";
  return EntitySchema2;
})(EntitySchema || {});

// src/nrk-base-tracker.ts
import cuid from "cuid";
var NrkBaseTracker = class {
  constructor(snowplow, config) {
    this.sharedEntities = {};
    var _a, _b, _c;
    this.snowplow = snowplow;
    this.trackerId = (_a = config.trackerId) != null ? _a : cuid.slug();
    this.setSharedEntity("iglu:no.nrk/service/jsonschema/2-0-0" /* Service */, { id: config.serviceId, environment: (_b = config.environment) != null ? _b : null });
    if (config.appVersion && config.appBuild) {
      this.setSharedEntity("iglu:com.snowplowanalytics.mobile/application/jsonschema/1-0-0" /* Application */, { build: config.appBuild, version: config.appVersion });
    }
    snowplow.newTracker(this.trackerId, config.collectorUrl, {
      postPath: "/nrk/wd6",
      appId: config.appId,
      plugins: config.plugins,
      platform: (_c = config.platform) != null ? _c : "web",
      contexts: {
        webPage: config.disableWebContext !== true
      },
      stateStorageStrategy: config.disableLocalStorage ? "cookie" : void 0
    });
  }
  trackPageView(contentEntity) {
    if (contentEntity) {
      this.snowplow.trackPageView(
        {
          context: entitiesToContexts(__spreadProps(__spreadValues({}, this.sharedEntities), {
            ["iglu:no.nrk/content/jsonschema/1-0-1" /* Content */]: contentEntity
          }))
        },
        [this.trackerId]
      );
    } else {
      this.snowplow.trackPageView({ context: entitiesToContexts(this.sharedEntities) }, [this.trackerId]);
    }
  }
  trackSchemaEvent(schema, data, entities) {
    const context = entitiesToContexts(__spreadValues(__spreadValues({}, this.sharedEntities), entities));
    this.snowplow.trackSelfDescribingEvent(
      {
        event: { schema, data: __spreadValues({}, data) },
        context
      },
      [this.trackerId]
    );
  }
  trackEvent(data, entities) {
    const context = entitiesToContexts(__spreadValues(__spreadValues({}, this.sharedEntities), entities));
    this.snowplow.trackStructEvent(__spreadProps(__spreadValues({}, data), { context }), [this.trackerId]);
  }
  setUser(userId) {
    this.snowplow.setUserId(userId, [this.trackerId]);
    this.setSharedEntity("iglu:no.nrk/nrk-user/jsonschema/1-0-0" /* NrkUser */, { id: userId });
  }
  clearUser() {
    this.snowplow.setUserId(null, [this.trackerId]);
    this.removeSharedEntity("iglu:no.nrk/nrk-user/jsonschema/1-0-0" /* NrkUser */);
  }
  addPlugin(configuration) {
    this.snowplow.addPlugin(configuration, [this.trackerId]);
  }
  setSharedEntity(schema, data) {
    this.sharedEntities[schema] = data;
  }
  getSharedEntity(schema) {
    return this.sharedEntities[schema];
  }
  removeSharedEntity(schema) {
    if (schema in this.sharedEntities) {
      delete this.sharedEntities[schema];
    }
  }
};
function entitiesToContexts(entities) {
  const contexts = [];
  Object.entries(entities).forEach(([schema, data]) => {
    const dataList = Array.isArray(data) ? data : [data];
    for (const entityData of dataList) {
      contexts.push({ schema, data: __spreadValues({}, entityData) });
    }
  });
  return contexts;
}

// src/nrk-player-tracker.ts
var NrkPlayerTracker = class extends NrkBaseTracker {
  setMedia(mediaId, details) {
    const content = { id: mediaId };
    if (details == null ? void 0 : details.source) {
      content.source = details == null ? void 0 : details.source;
    }
    if (details == null ? void 0 : details.kind) {
      content.kind = details == null ? void 0 : details.kind;
    }
    this.setSharedEntity("iglu:no.nrk/content/jsonschema/1-0-1" /* Content */, content);
    if (details == null ? void 0 : details.channelId) {
      this.channelId = details.channelId;
    }
    if (details && "autoplay" in details && details.autoplay !== void 0) {
      this.autoplay = details.autoplay;
    }
  }
  setMediaAutoplay(autoplay) {
    this.autoplay = autoplay;
  }
  setUnknownMedia(channelId) {
    this.setSharedEntity("iglu:no.nrk/content/jsonschema/1-0-1" /* Content */, { id: "unknown", kind: "unknown" });
    this.channelId = channelId;
  }
  sendStartEvent(startTime, live) {
    if (this.getSharedEntity("iglu:no.nrk/content/jsonschema/1-0-1" /* Content */) === void 0) {
      throw new Error("Must use setMedia() first!");
    }
    const start = Math.max(0, Math.floor(startTime));
    this.trackSchemaEvent("iglu:no.nrk/playback-event/jsonschema/1-0-0" /* PlaybackEvent */, {
      kind: "start" /* Start */,
      startTime: start,
      endTime: start,
      autoplay: this.autoplay,
      live,
      channelId: this.channelId
    });
  }
  sendProgressEvent(startTime, endTime, live) {
    this.sendPlaybackEvent("progress" /* Progress */, startTime, endTime, live);
  }
  sendCompleteEvent(startTime, endTime, live) {
    this.sendPlaybackEvent("complete" /* Complete */, startTime, endTime != null ? endTime : startTime, live);
  }
  sendExitEvent(startTime, endTime, live) {
    this.sendPlaybackEvent("exit" /* Exit */, startTime, endTime != null ? endTime : startTime, live);
  }
  sendPlaybackEvent(kind, startTime, endTime, live) {
    const start = Math.max(0, Math.floor(startTime));
    const end = Math.max(0, Math.floor(endTime));
    if (start === end && kind === "progress" /* Progress */) {
      return;
    }
    if (start > end) {
      throw new Error(`Start time can't be after end time (${start} vs ${end}). Event was ${kind}`);
    }
    this.trackSchemaEvent("iglu:no.nrk/playback-event/jsonschema/1-0-0" /* PlaybackEvent */, {
      kind,
      startTime: start,
      endTime: end,
      live,
      channelId: this.channelId
    });
  }
};

// src/service-id.ts
var ServiceID = /* @__PURE__ */ ((ServiceID2) => {
  ServiceID2["Embed"] = "embed";
  ServiceID2["Nrkbeta"] = "nrkbeta";
  ServiceID2["Nrkinnlogging"] = "nrkinnlogging";
  ServiceID2["Nrkno"] = "nrkno";
  ServiceID2["Nrkp3"] = "nrkp3";
  ServiceID2["Nrkradio"] = "nrkradio";
  ServiceID2["Nrksuper"] = "nrksuper";
  ServiceID2["Nrktv"] = "nrktv";
  ServiceID2["Yr"] = "yr";
  return ServiceID2;
})(ServiceID || {});

// src/snowplow-global.ts
var SnowplowGlobal = class {
  constructor() {
    this.snowplow = window.snowplow;
    if (this.snowplow === void 0) {
      throw new Error("There is no global Snowplow function.");
    }
  }
  static isAvailable() {
    return window.snowplow !== void 0;
  }
  newTracker(trackerId, collectorUrl, configuration) {
    this.snowplow("newTracker", trackerId, collectorUrl, configuration);
    if ((configuration == null ? void 0 : configuration.plugins) !== void 0) {
      configuration.plugins.forEach((plugin) => {
        this.addPlugin({ plugin }, [trackerId]);
      });
    }
  }
  setUserId(...args) {
    this.proxy("setUserId", args, 2);
  }
  trackPageView(...args) {
    this.proxy("trackPageView", args, 2);
  }
  trackSelfDescribingEvent(...args) {
    this.proxy("trackSelfDescribingEvent", args, 2);
  }
  trackStructEvent(...args) {
    this.proxy("trackStructEvent", args, 2);
  }
  preservePageViewId(...args) {
    this.proxy("preservePageViewId", args, 1);
  }
  addPlugin(config, trackers) {
    const args = [{ Plugin: () => config.plugin }, "Plugin", trackers];
    this.proxy("addPlugin", args, args.length);
  }
  proxy(method, args, maxArgs) {
    const trackerIds = args.length === maxArgs ? args.pop() : void 0;
    if (trackerIds && trackerIds.length > 0) {
      trackerIds.forEach((trackerId) => {
        this.snowplow(`${method}:${trackerId}`, ...args);
      });
    } else {
      this.snowplow(method, ...args);
    }
  }
};
export {
  ClickEventKind,
  EntitySchema,
  EventSchema,
  ImpressionEventKind,
  NrkBaseTracker,
  NrkPlayerTracker,
  PlaybackEventKind,
  SearchSource,
  ServiceID,
  SnowplowGlobal,
  entitiesToContexts
};
